import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20overhead%20shot%20of%20fashion%20products%20including%20sneakers%20bags%20and%20accessories%20arranged%20in%20organized%20rows%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20from%20large%20window%20clean%20minimalist%20catalog%20style%20editorial%20product%20photography%20with%20plenty%20of%20empty%20space%20for%20text%20overlay&width=1920&height=800&seq=cta-bg-v2&orientation=landscape"
          alt="AllChinaBuy fashion products"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/55"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="text-white">
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-4">Start Shopping</p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold leading-tight mb-4">Start Exploring the Best<br />AllChinaBuy Spreadsheet Today</h2>
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-md mb-8">
              Find trusted products faster and shop with confidence. Our curated spreadsheet gives you instant access to verified sellers and quality-checked items.
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 bg-accent-500 text-foreground-950 font-semibold text-sm rounded-full hover:bg-accent-400 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2">
                AllChinaBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link to="/allchinabuy-spreadsheet-guide" className="px-7 py-3.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold text-sm rounded-full hover:bg-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2">
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="bg-background-50/95 backdrop-blur-sm rounded-2xl p-8 md:p-10">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100"><i className="ri-user-star-line text-lg text-primary-600"></i></div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">Trusted by Thousands</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">Join a growing community of buyers who rely on our spreadsheet for verified product links.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100"><i className="ri-price-tag-3-line text-lg text-accent-600"></i></div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">Best Prices Available</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">Compare prices across multiple verified sellers to find the best deals.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100"><i className="ri-secure-payment-line text-lg text-secondary-600"></i></div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">Safe Buying Guides</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">Access comprehensive safety guides covering payment protection and seller verification.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}